import React from "react";
import { useNavigate } from "react-router-dom";
import { LayoutWithTopBar } from "../../../components/LayoutWithTopBar";
import { Button, ButtonSize } from "../../../components/Button";
import { useTheme } from "../../../hooks/useTheme";
import { useAuth } from "../../../hooks/useAuth";
import { useWallet } from "../../../hooks/useWallet";
import { useConfirm } from "../../../hooks/useConfirm";
import { ButtonVariant } from "../../../config/colors";
import { ButtonAlignement } from "../../../components/ConfirmModal";
import { SeedPhraseDisplay } from "./components/SeedPhraseDisplay";

const ViewSeed: React.FC = () => {
  const navigate = useNavigate();
  const { isMobile } = useTheme();
  const { pleb } = useAuth();
  const { deleteWallet } = useWallet();
  const { openConfirm } = useConfirm();

  const handleDeleteWallet = () => {
    openConfirm({
      title: "Delete wallet",
      message:
        "This removes your wallet and all sats from this device. After deleting, you can import an existing wallet or create a new one. Are you sure?",
      buttons: [
        { label: "Cancel", onClick: () => {}, variant: ButtonVariant.transparent },
        {
          label: "Delete wallet",
          onClick: () => {
            if (pleb) {
              deleteWallet(pleb);
              navigate("/home/wallet");
            }
          },
          variant: ButtonVariant.danger,
        },
      ],
      buttonAlignement: ButtonAlignement.row,
    });
  };

  return (
    <LayoutWithTopBar
      breadcrumbs={[
        { title: "Wallet", onClick: () => navigate("/home/wallet") },
        { title: "Seed" },
      ]}
      onClickPrevArrow={() => navigate(-1)}
      hideLineActiveCall
    >
      <div className="flex flex-col gap-6 p-4">
        <div className="text-base opacity-70 text-center">
        Your seed phrase stays on your device and is never sent to our servers.
        </div>

        <SeedPhraseDisplay />

        <div className="flex justify-center">
          <Button
            variant={ButtonVariant.transparent}
            onClick={handleDeleteWallet}
            size={ButtonSize.small}
          >
            Delete wallet
          </Button>
        </div>
      </div>
    </LayoutWithTopBar>
  );
};

export default ViewSeed;

